import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ChangeDetectorRef, AfterViewChecked, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { Checklist } from '../validation-checklist/validation-checklist.component';
declare var $;
export class WizardStep {
  id: number | string;
  name: string;
  isValid: () => boolean;
}

@Component({
  selector: 'app-wizard-wrapper',
  templateUrl: './wizard-wrapper.component.html',
  styleUrls: ['./wizard-wrapper.component.css']
})
export class WizardWrapperComponent implements OnInit, AfterViewInit, AfterViewChecked {

  @Input() steps: WizardStep[] = [];
  @Input() form: NgForm;
  @Input() editMode = false;
  @Input() viewMode = false;
  @Input() isHide = true;
  @Input() isSpecificPage = false;
  @Input() hidePrevNextButtons = true;
  @Input() isShowUpdate = true;
  @Input() UpdateAndAddNew = true;
  @Input() qualificationArr = false;
  @Input() isSubmitting = false;
  @Input() checklist: Checklist[] = [];
  currentStep = 0;
  visibleSteps = [];
  isNextPrevVisible = false;
  constructor(private cdr: ChangeDetectorRef) { }
  @Output() cancel_ev: EventEmitter<any> = new EventEmitter();
  @Output() saveAndNew: EventEmitter<any> = new EventEmitter();
  @Output() saveOnly: EventEmitter<any> = new EventEmitter();
  @Output() updateAndNew: EventEmitter<any> = new EventEmitter();
  @Output() updateOnly: EventEmitter<any> = new EventEmitter();
  @Output() clear: EventEmitter<any> = new EventEmitter();
  @Output() stepChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('perfectScroll') perfectScroll: PerfectScrollbarComponent;

  ngOnInit() {
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    $('#smartwizard').smartWizard(
      {
        selected: this.currentStep,  // Initial selected step, 0 = first step
        keyNavigation: false, // Enable/Disable keyboard navigation(left and right keys are used if enabled)
        autoAdjustHeight: true, // Automatically adjust content height
        cycleSteps: false, // Allows to cycle the navigation of steps
        backButtonSupport: true, // Enable the back button support
        useURLhash: false, // Enable selection of the step based on url hash
        lang: {  // Language variables
          next: 'Next',
          previous: 'Previous'
        },
        toolbarSettings: {
          toolbarPosition: 'bottom', // none, top, bottom, both
          toolbarButtonPosition: 'left', // left, right
          showNextButton: false, // show/hide a Next button
          showPreviousButton: false, // show/hide a Previous button
          toolbarExtraButtons: [
            // $('<button></button>').text('Finish')
            //   .addClass('btn btn-info')
            //   .on('click', () => {
            //     alert('Finsih button click');
            //   }),
            // $('<button></button>').text('Cancel')
            //   .addClass('btn btn-danger')
            //   .on('click', () => {
            //     alert('Cancel button click');
            //   })
          ]
        },
        anchorSettings: {
          anchorClickable: true, // Enable/Disable anchor navigation
          enableAllAnchors: this.viewMode, // Activates all anchors clickable all times in view mode
          markDoneStep: true, // add done css
          enableAnchorOnDoneStep: true // Enable/Disable the done steps navigation
        },
        contentURL: null, // content url, Enables Ajax content loading. can set as data data-content-url on anchor
        disabledSteps: this.viewMode ? [] : [],    // Array Steps disabled - no steps disabled in view mode
        errorSteps: [],    // Highlight step with errors
        theme: 'dots',
        transitionEffect: 'fade', // Effect on navigation, none/slide/fade
        transitionSpeed: '400',
        showStepURLhash: false
      }
    );

    // Initialize the leaveStep event
    $('#smartwizard').on('leaveStep', (e, anchorObject, stepNumber: number, stepDirection) => {
      if (stepDirection === 'forward') {
        this.currentStep = stepNumber + 1;
        this.stepChange.emit({
          currentStep: stepNumber,
          nextStep: this.currentStep
        });
      } else {
        this.currentStep = stepNumber - 1;
        this.stepChange.emit({
          currentStep: stepNumber,
          nextStep: this.currentStep
        });
      }
    });
    this.onResize();
  }

  calculateVisibility() {
    this.visibleSteps = [];
    const visibleSteps = Math.floor($('#view-container').width() / 192);
    this.visibleSteps.push(0);
    this.visibleSteps.push(visibleSteps - 1);
    if (this.steps.length > this.visibleSteps[1]) {
      this.isNextPrevVisible = true;
    } else {
      this.isNextPrevVisible = false;
    }
  }

  onResize() {
    this.calculateVisibility();
    this.manageVisibilityOfSteps();
  }

  nextStep() {
    if (this.visibleSteps[1] === this.steps.length - 1) {
      return;
    }
    this.visibleSteps[0] += 1;
    this.visibleSteps[1] += 1;
    this.manageVisibilityOfSteps();
  }

  previousStep() {
    if (this.visibleSteps[0] === 0) {
      return;
    }
    this.visibleSteps[0] -= 1;
    this.visibleSteps[1] -= 1;
    this.manageVisibilityOfSteps();
  }

  manageVisibilityOfSteps() {
    const children = $('#view-container').children();
    // tslint:disable-next-line:no-increment-decrement
    for (let index = 0; index < this.steps.length; index++) {
      if (index < this.visibleSteps[0] || index > this.visibleSteps[1]) {
        $(children[index]).css('display', 'none');
      } else {
        $(children[index]).css('display', 'block');
      }
    }
    this.perfectScroll.directiveRef.scrollToTop(0,0);
  }

  forceNext() {
    if (this.currentStep >= this.visibleSteps[1]) {
      this.nextStep();
    }else{
      this.perfectScroll.directiveRef.scrollToTop(0,0);
    }
  }

  forcePrevious() {
    if (this.currentStep <= this.visibleSteps[0]) {
      this.previousStep();
    }else{
      this.perfectScroll.directiveRef.scrollToTop(0,0);
    }
  }

  onCancel() {
    this.cancel_ev.emit(true);
  }

  clickSaveAndNew() {
    if (!this.isSubmitting) {
      this.saveAndNew.emit(true);
    }
  }

  clickSaveOnly() {
    this.saveOnly.emit(true);
  }

  clickUpdateAndNew() {
    if (!this.isSubmitting) {
      this.updateAndNew.emit(true);
    }
  }

  clickUpdateOnly() {
    if (!this.isSubmitting) {
      this.updateOnly.emit(true);
    }
  }

  onClear() {
    this.clear.emit(true);
  }

  /**
   * Check if all mandatory checklist items are valid
   */
  isChecklistValid(): boolean {
    if (!this.checklist || this.checklist.length === 0) {
      return true;
    }
    
    for (const checklistGroup of this.checklist) {
      if (checklistGroup.childrens) {
        for (const item of checklistGroup.childrens) {
          if (item.isMandatory && item.isVisible && !item.isValid()) {
            return false;
          }
        }
      }
    }
    return true;
  }

  /**
   * Check if form and checklist are both valid
   */
  isFormAndChecklistValid(): boolean {
    return this.form.valid && this.isChecklistValid();
  }

}
